import { render, staticRenderFns } from "./kultouren.vue?vue&type=template&id=6820cfec&scoped=true"
import script from "./kultouren.vue?vue&type=script&lang=js"
export * from "./kultouren.vue?vue&type=script&lang=js"
import style0 from "./kultouren.vue?vue&type=style&index=0&id=6820cfec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820cfec",
  null
  
)

export default component.exports